<template>
<div class="section team">
  <div class="section__header">
    <h2>Страница команды</h2>
    <back></back>

    <div v-if="team" class="team__info">
      <!-- <img :src="team.logo" alt="эмблема"> -->
      <p class="team__name">{{ team.student.name }}</p>
      <!-- <p class="team__text">({{ getLevelTitle(team.level) }})</p>
      <p class="team__text">{{ team.slogan }}</p> -->
    </div>
  </div>

  <div class="section__body tasks" v-if="team"> 
    <h3>Задания для третьего этапа</h3>

    <div class="tasks__container">
      <div class="tasks__students">
        <h4>Ученики</h4>
        <ul class="tasks__students-list">
          <li class="tasks__student" v-for="member in team.members" :key="member.id">
            <div>
              <span><i class="far fa-user"></i> {{ member.name }}</span>  
              <!-- <button 
                type="button" 
                class="header-menu__btn header-menu__btn--remove" 
                @click="openPopup('MatriusStudentMove', member.id)"
                uk-tooltip="Перенести"
              >
                <i class="fas fa-angle-double-right"></i>
              </button>
              
              <button 
                type="button" 
                class="header-menu__btn header-menu__btn--remove" 
                @click="removeStudent(member.id, i)"
                uk-tooltip="Удалить из команды"
              >
                <i class="fas fa-trash-alt"></i>
              </button> -->
            </div>

            <div class="tasks__trainers">
              <div class="trainers-list" v-if="team.trainers_3">
                <!-- <span>{{ member.can_do ? 'Доступно' : 'Недоступно' }}</span> -->
                <div 
                  class="trainers-dot"
                  :class="{
                    done: checkTrainerComplete(item, member.student_tasks),
                    undone: !checkTrainerComplete(item, member.student_tasks)
                  }"
                  v-for="item in team.trainers_3" 
                  :key="item.id"
                  @click="openPopup('AddTrainer', {id: member.id, data: item})"
                >
                  <div class="trainer-stat" v-html="getTrainerInfo(item, member)"></div>

                </div>
              </div>
              <span 
                v-else
                uk-tooltip="Добавить задание"
                class="add-trainer" 
                @click="openPopup('AddTrainer', {id: member.id, data: null})"
              >
                <i class="fas fa-plus-circle"></i>
              </span>
            </div> 
         
            
          </li>
        </ul>
      </div>
    </div>    
  </div>

  <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData"
        :student_id="user_id"
        :team_id="team.id"
        :task_id="task_id"

        @close-popup="popupIsOpened = false" 
        @complete-task="completeTask"
        @add-trainers="addTrainers"
        @move-student="deleteItem($event, team.members)"
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import { matrius_task } from './matrius_task_mix'
import { getLevelTitle } from './levels'
import { popup_mix } from '../../../mixins/popup_mix'
import { deleteItem } from '../../../other/methods/list_actions'

import AddTrainer from './AddTrainer.vue'
import MatriusStudentMove from './MatriusStudentMove'
import moment from 'moment'
export default {
  inject: ['http'],
  mixins: [ popup_mix, matrius_task ],
  components: { AddTrainer, MatriusStudentMove },
  data() {
    return {
      team: null,
      user_id: null,
      task_id: null,
    }
  },
  computed: {    
    attachedTasks() {
      return this.team.student_tasks.filter(item => item.student)
    },
    unattachedTasks() {
      return this.team.student_tasks.filter(item => !item.student)
    },
    teacher_id() {
      return this.team.teacher_id
    }
  },
  methods: {
    getLevelTitle,
    deleteItem,
    checkTrainerComplete(trainer, tasks) {
      if (tasks.length) {
        let stats = tasks[0].stats
        let completed = stats.find(item => item.trainer_id === trainer.trainer.id)

        return completed ? true : false
      }
      
      return false
    },
    getTrainerInfo(trainer, member) {
      let tasks = member.student_tasks      

      let html = `
            <strong>${trainer.trainer.title}</strong>
            <span>Не выполнено</span>
          `
      if (tasks.length) {
        let stats = tasks[0].stats
        let completed = stats.find(item => item.trainer_id === trainer.trainer.id) 
        
        if (completed) {
          html = `
            <strong>${trainer.trainer.title}</strong>
            <span>количество: ${completed.count}</span>
            <span>ошибки: ${completed.errors}</span>
            <span>баллы: ${completed.matrius_scores}</span>
          `
        } else {
          let from = moment(member.task_from, 'YYYY-MM-DD').format('DD.MM.YYYY')
          let to = moment(member.task_to, 'YYYY-MM-DD').format('DD.MM.YYYY')
          let isWached = member.viewed_trainers.includes(trainer.trainer.title)
          
          html = `
            <strong>${trainer.trainer.title}</strong>
            <span>Не выполнено</span>
            <span>${from} - ${to}</span>
            <span>${ isWached ? 'Просмотрено' : 'Не просмотрено' }</span>
          `
        }     
      }
      return html
    },
    addTrainers(data) {
      this.team.trainers_3 = data.trainers
    },
    getDeadLine(task) {
      let date = moment(task.date, 'YYYY-MM-DD').add(1, 'days').format('DD.MM.YYYY')
      return date
    },
    getHomeWorkPeriod(task) {
      let deadline = this.getDeadLine(task)
      let start = moment(deadline, 'DD.MM.YYYY').subtract(6, 'days').format('DD.MM')
      return start + ' - ' + deadline
    },
    openTask(task, user_id) {
      this.openPopup('MatriusTaskPopup', task.task); 
      this.user_id = user_id
      this.task_id = task.id
    },
    checkCompleted(task) {
      let current = new Date()
      let taskDate = new Date(task.date)
      taskDate.setDate(taskDate.getDate() + 1)

      current.setHours(0,0,0,0)
      taskDate.setHours(0,0,0,0)

      if (current.getTime() === taskDate.getTime() && !task.is_done) {
        return true
      } else {
        return false
      }
    },
    viewTask(task) {
      let item = task.task
      item.is_done = task.is_done
      item.is_right = task.is_right
      item.user_answer = task.answer
      this.openPopup('MatriusTaskPopup', item)
    },
    completeTask(data) {
      console.log(data)
      let task = this.team.student_tasks.find(item => item.id === data.id)
      task.is_done = data.is_done
      task.is_right = data.is_right
      task.answer = data.answer
    },
    getTeamById() {
      let team_id = this.$route.params.id
      this.http.post('onGetTeam', { team_id }).then(res => {
        this.team = res.data 

        let student = this.team.student
        student.student_tasks = []
        this.team.members = [student]
        console.log(this.team)       
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
    },
    removeStudent(id, index) {
      swal({
        title: 'Внимание!',
        text: `Удалить ученика из команды?`,
        icon: "warning",
        buttons: ['Отмена', 'Да'],
        dangerMode: true,
      })
      .then((choise) => {
        if (choise) {
          let data = {
            member_id: id
          }
          this.http.post('onDeleteTeamStudent', data).then(() => {
            this.team.members.splice(index, 1)
            swal('Успешно!', 'Ученик удален', 'success')
          }) 
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
        } 
      })
    }
  },
  created() {
    this.getTeamById()
  }
}
</script>

<style lang="scss" scoped>
.team__info {
  margin-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  & img {
    width: 60px;
    border-radius: 8px;
  }
}
.team__name,
.team__text {
  margin: 0;
}
.team__name {
  margin-top: 10px;
  font-size: 20px;
  color: #666666;
}
.team__text {
  font-size: 14px;
  color: #999999;
}

.tasks__container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.tasks__students-list {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  margin-top: 20px;
  list-style: none;
}
.tasks__student {
  margin-top: 5px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #e2e2e2;

  & .add-trainer {
    color: #1e87f0;
    cursor: pointer;
    font-size: 22px;
  }
}

.tasks__students {
  box-sizing: border-box;
  width: 100%;
  max-width: 600px;
  padding: 20px;
  margin-right: 20px;
  border: 1px solid #1e87f0;
  border-radius: 8px;
  & h4 {
    margin: 0;
  }
}

.tasks__item {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #e2e2e2;
  margin-bottom: 10px;
  border-left-width: 10px;

  &.error {
    border-left-color: rgb(255, 91, 91);
  }

  &.success {
    border-left-color: rgb(47, 255, 47);
  }
}

.task-info,
.task-status {
  display: flex;
  flex-direction: column;

  & span:first-child {
    font-size: 18px;
  }
  & span:not(:first-child) {
    font-size: 14px;
  }
}
.task-info {
  margin-right: 20px;
}
.task-info .date {
  font-size: 12px;
  color: #999999;
}

.trainers-dot {
  width: 20px;
  height: 20px;
  background-color: #e4e4e4;
  border-radius: 50%;
  margin-left: 10px;
  cursor: pointer;
  &:hover .trainer-stat {
    display: flex;
  }

  &.done {
    background-color: #34f32e;    
  }
  &.undone {
    background-color: #f32e2e;
  }  
}

.trainers-list {
  display: flex;
  position: relative;

}
.trainer-stat {
  left: -70px;
  bottom: 20px;
  display: none;
  position: absolute;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  width: 200px;
  font-size: 12px;
  border: 2px solid #1e87f0;
  border-radius: 6px;
}

@media (max-width: 730px) {
  .tasks__container {
    flex-direction: column;
  }

  .tasks__students {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
}
</style>